import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface DeleteFromTeamConfirmationDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  handleClose: () => void;
  handleConfirm: () => void;
}

const DeleteFromTeamConfirmationDialog = ({
  isOpen,
  title,
  message,
  handleClose,
  handleConfirm,
}: DeleteFromTeamConfirmationDialogProps) => {
  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleConfirm} color="error" autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteFromTeamConfirmationDialog; 